module.exports = __webpack_public_path__ + "img/face-confused.2b8edf41.svg";